export enum PaymentStatusType {
  Pending = "PENDING",
  Submitted = "SUBMITTED",
  CheckPrinted = "CHECK_PRINTED",
  CheckMailed = "CHECK_MAILED",
  CashDisbursed = "CASH_DISBURSED",
  CreditApplied = "CREDIT_APPLIED",
  Cancelled = "CANCELLED",
  Error = "ERROR",
  Processed = "PROCESSED",
  Processing = "PROCESSING"
}
